var editScript = `<script>
$(".input_field_group input").each(function(){
  if($(this).val() != ""){
    $(this).addClass("onfocus");
  }
});


$(".input_field_group input").focusin(function(e) {
  $(this).addClass("onfocus");
}).focusout(function(e) {
  if( $(this).val() == "" ){
    $(this).removeClass("onfocus");
  }
});


$(".input_field_group select").each(function(){
if($(this).val() != ""){
  $(this).addClass("onfocus");
}
});

$(".input_field_group select").focusin(function(e) {
$(this).addClass("onfocus");
}).focusout(function(e) {
if( $(this).val() == "" ){
  $(this).removeClass("onfocus");
}
});
</script>`;
//if($('#account-close-panel') || $('.account-address-panel-inner.close-panel')) {
$("#account-close-panel").on("click", () => {
  $("#account-address-panel .content").removeClass("open-panel");
  $("#account-address-panel .content").addClass("close-panel");
  setTimeout(() => {
    $("#account-address-panel").removeClass("account-address-panel");
    $("#account-address-panel").addClass("account-address-panel-close");
    $("#account-address-panel #account-close-panel").addClass("d-none");
    $("#account-address-panel #form").addClass("d-none");
    $("body").removeClass("overflow__hidden");
  }, 500);
});
//}

$("#open-account-address").on("click", () => {
  $("#account-address-panel").removeClass("account-address-panel-close");
  $("#account-address-panel").addClass("account-address-panel");
  $("#account-address-panel .content").addClass("open-panel");
  $("#account-address-panel .content").removeClass("close-panel");
  $("#account-address-panel #account-close-panel").removeClass("d-none");
  $("#account-address-panel #form").removeClass("d-none");
  $("body").addClass("overflow__hidden");

  // reset the initial value of state field to empty;
  document.getElementById("AddressStateNew").value = "";
  $("select#AddressCountryNew").removeClass("onfocus");
  $("select#AddressStateNew").removeClass("onfocus");
});

$("#open-account-address2").on("click", () => {
  $("#account-address-panel").removeClass("account-address-panel-close");
  $("#account-address-panel").addClass("account-address-panel");
  $("#account-address-panel .content").addClass("open-panel");
  $("#account-address-panel .content").removeClass("close-panel");
  $("#account-address-panel #account-close-panel").removeClass("d-none");
  $("#account-address-panel #form").removeClass("d-none");
  $("body").addClass("overflow__hidden");

  document.getElementById("AddressStateNew").value = "";
  $("select#AddressCountryNew").removeClass("onfocus");
  $("select#AddressStateNew").removeClass("onfocus");
});
$(".open-account-address-edit").click(function () {
  let editaddressid = $(this).attr("edit-form-id");
  //console.log(editaddressid);

  let getEditInner = $("#form_" + editaddressid).html();
  //console.log(getEditInner);

  $("#account-edit-inner").empty();
  $("#account-edit-inner").append(getEditInner);
  $("#account-edit-inner").append(editScript);

  $("#account-address-edit-panel").removeClass(
    "account-address-edit-panel-close"
  );
  $("#account-address-edit-panel").addClass("account-address-edit-panel");
  $("#account-address-edit-panel .content").addClass("open-panel");
  $("#account-address-edit-panel .content").removeClass("close-panel");
  $(
    "#account-address-edit-panel #account-address-edit-close-panel"
  ).removeClass("d-none");
  $("#account-address-edit-panel #form").removeClass("d-none");
  $("body").addClass("overflow__hidden");

  let countrySelected = document
    .querySelector("#AddressCountry_" + editaddressid)
    .getAttribute("data-default");

  let state = document
    .querySelector("#AddressState_" + editaddressid)
    .getAttribute("data-default");

  let countryField = document.getElementById("AddressCountry_" + editaddressid);

  let stateField = document.getElementById("AddressState_" + editaddressid);

  repopulateStatesForEdit(editaddressid, state);

  countryField.value = countrySelected;
  stateField.value = state;

    if (!state || state === "") {
      $("#AddressState_" + editaddressid).removeClass("onfocus");
    }

    if (countrySelected !== "United States") {
      $("#AddressState_" + editaddressid).parent().hide();
    }
});

$("#account-address-edit-close-panel").on("click", () => {
  $("#account-address-edit-panel .content").removeClass("open-panel");
  $("#account-address-edit-panel .content").addClass("close-panel");
  setTimeout(() => {
    $("#account-address-edit-panel").removeClass("account-address-edit-panel");
    $("#account-address-edit-panel").addClass("account-address-panel-close");
    $("#account-address-edit-panel #account-address-edit-close-panel").addClass(
      "d-none"
    );
    $("#account-address-edit-panel #form").addClass("d-none");
    $("body").removeClass("overflow__hidden");
  }, 500);
});

$(document).on("click", (e) => {
  const panelAddressEdit = $(".account-address-edit-panel");
  if (panelAddressEdit.is(e.target)) {
    $("#account-address-edit-close-panel").click();
  }

  const panelAddress = $(".account-address-panel");
  if (panelAddress.is(e.target)) {
    $("#account-close-panel").click();
  }
});

$(document).ready(function () {
  $("#AddressCountryNew").val("---");
  $('select#AddressCountryNew option:contains("---")').text("");

  var countryDropdownForNew = $("#AddressCountryNew");
  repopulateStatesForNewAddress();

  countryDropdownForNew.on("change", function () {
    if (countryDropdownForNew.val() && countryDropdownForNew.val() !== "United States") {
      $("#AddressStateNew").prop('required',false).val("").parent().hide();
      if (countryDropdownForNew.val() === "") {
        $("select#AddressCountryNew").removeClass("onfocus");
      }
    } else {
      $("#AddressStateNew").prop('required',true).parent().show();
      if ($("select#AddressCountryNew").val() === "") {
        $("select#AddressCountryNew").removeClass("onfocus");
      }
    }
  });

  $(".input_field_group input").each(function () {
    if ($(this).val() != "") {
      $(this).addClass("onfocus");
    }
  });

  $(".input_field_group input")
    .focusin(function (e) {
      $(this).addClass("onfocus");
    })
    .focusout(function (e) {
      if ($(this).val() == "") {
        $(this).removeClass("onfocus");
      }
    });

  $(".input_field_group select").each(function () {
    if ($(this).val() != "") {
      $(this).addClass("onfocus");
    }
  });

  $(".input_field_group select")
    .focusin(function (e) {
      $(this).addClass("onfocus");
    })
    .focusout(function (e) {
      if ($(this).val() == "") {
        $(this).removeClass("onfocus");
      }
    });

  var addressFormId = $(".open-account-address-edit").attr("edit-form-id");
  var countryDropdownForEdit = $("#AddressCountry_" + addressFormId);
  $("#AddressCountry_" + addressFormId + "option:first").text(
    countryDropdownForEdit.attr("data-default")
  );
});

function repopulateStatesForNewAddress() {
  var stateDropdown = $("#AddressStateNew");
  stateDropdown.empty();
  loadStates(stateDropdown, undefined);
}

function repopulateStatesForEdit(addressFormId, state) {
  var stateDropdown = $("#AddressState_" + addressFormId);
  stateDropdown.empty();
  loadStates(stateDropdown, state);
}
function loadStates(stateDropdown, selectedState) {

  if (!selectedState || selectedState === "") {
    stateDropdown.append($('<option value="" disabled selected></option>'));
  } else {
    stateDropdown.append($('<option value="" disabled></option>'));
  }

  $.getJSON(stateDropdown.attr("data-state-url"), function (data) {
    data.countries.forEach((countrystate) => {
      if (countrystate.country === "United States of America") {
        countrystate.states.forEach((state) => {
          if (state === selectedState) {
            stateDropdown.append(
                $("<option></option>").attr({"value": state, "selected": "selected"}).text(state)
            );
          } else {
            stateDropdown.append(
                $("<option></option>").attr("value", state).text(state)
            );
          }
        });
      }
    });
  });
}
